import React, { useMemo } from "react";

import PropTypes from "prop-types";
import { MOBILE_MAX_991_WIDTH } from "utils/constants";
import useWindowDimensions from "utils/hooks/useWindowDimensions";

import MenuItem from "./MenuItem";
import "./styles.scss";

const Menu = ({ items, selected }) => {
  const { width } = useWindowDimensions();
  const ITEMS = useMemo(
    () =>
      items.filter(
        ({ onlyMobile }) =>
          !onlyMobile || (onlyMobile && width < MOBILE_MAX_991_WIDTH),
      ),
    [items, width],
  );

  return (
    <div className={"menu-bar"}>
      {ITEMS.map(({ key, text, icon, disabled, onClick }) => (
        <MenuItem
          key={`menu:${key}`}
          text={text}
          icon={icon}
          disabled={disabled}
          selected={key === selected}
          onClick={() => {
            onClick && onClick();
          }}
        />
      ))}
    </div>
  );
};

Menu.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      icon: PropTypes.node,
      disabled: PropTypes.bool,
      onClick: PropTypes.func,
    }),
  ),
  selected: PropTypes.string.isRequired,
};

Menu.defaultProps = {
  title: "",
};
export default Menu;
